module.exports = __webpack_public_path__ + "img/icon-repair.a1cd1608.svg";